import { PrimaryDiagnosisDetails } from "../../data-model/medicalPaOrdersModel";
import { FirestoreService } from "../firebase/firestoreService";
import {
  FirestoreCollectionReference,
  FirestoreDocumentReference,
} from "../firebase/references";

export const updatePrimaryDiagnosisCode = async (
  orderId: string,
  newIcdCode: string,
  newIcdDescription?: string,
  overwrite: boolean = false,
): Promise<void> => {
  try {
    const currentDoc = await FirestoreService.getDocument<any>(
      FirestoreDocumentReference.medicalPaOrders(orderId),
    );

    if (!currentDoc) {
      throw new Error("Document not found");
    }

    let primaryDiagnosisDetails: PrimaryDiagnosisDetails[] = [];

    if (
      currentDoc.primary_diagnosis_details &&
      Array.isArray(currentDoc.primary_diagnosis_details)
    ) {
      primaryDiagnosisDetails = [...currentDoc.primary_diagnosis_details];
    } else {
      primaryDiagnosisDetails = [];
    }

    if (overwrite) {
      primaryDiagnosisDetails = [
        {
          diagnosis: "",
          icd_code: newIcdCode,
          icd_description: newIcdDescription || "",
        },
      ];
    } else {
      if (primaryDiagnosisDetails[0]) {
        primaryDiagnosisDetails[0] = {
          ...primaryDiagnosisDetails[0],
          icd_code: newIcdCode,
        };
      } else {
        primaryDiagnosisDetails[0] = {
          diagnosis: "",
          icd_code: newIcdCode,
          icd_description: "",
        };
      }
    }

    await FirestoreService.updateDocument(
      FirestoreCollectionReference.medicalPaOrders(),
      orderId,
      {
        primary_diagnosis_details: primaryDiagnosisDetails,
      },
    );
  } catch (error) {
    console.error("Error updating primary diagnosis code:", error);
    throw error;
  }
};
